import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {SharedService} from "../../../../core/services/store/shared-store/shared-storage.service";
import {Observable} from "rxjs";
import {FlowManagerService} from "../../../flow/services/flow-manager.service";
import {environment} from "../../../../../environments/environment";
import {catchError, map} from "rxjs/operators";
import {FlowMetaData} from "../../../../shared/models";

@Injectable({
    providedIn: 'root'
})
export class TimeoutEventService {

    private readonly TIMEOUT_FLOW_NAME: string = "Timeout Flow";

    constructor(
        private httpClient: HttpClient,
        private sharedService: SharedService
    ) {
    }

    private getTimeout() {
        //TODO: needs an actual working end point
        return `${environment.controlBaseUrl}`;
    }

    private httpOptions = {
        headers: new HttpHeaders({
            'accept': 'application/json',
            'X-API-VERSION': '1',
        }),
        withCredentials: false,
        observe: 'response' as 'body'
    };

    getFeatureContent(): Observable<any> {
        return this.httpClient
            .get(
                this.getTimeout() + `/feature/config/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`,
                this.httpOptions
            );
    }

    setFeatureContent(params): Observable<any> {
        return this.httpClient
            .post(
                this.getTimeout() + `/feature/config/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}`,
                params,
                this.httpOptions
            );
    }

    getFlowId(): Observable<any> {
        const url = this.getTimeout() + `/api/v3/${this.sharedService.getEnvironment()}/${this.sharedService.getEntityType()}/${this.sharedService.getEntityId()}/flows/metadata/${encodeURIComponent(this.TIMEOUT_FLOW_NAME)}`;
        return this.httpClient.get<FlowMetaData>(url)
            .pipe(
                map((metadata: FlowMetaData) => metadata.flowId),
                catchError(() => undefined)
            );
    }
}
